import request from '@/utils/request'
//1. getBlkInfo
export function getBlkInfo(param) {
    let data = param
    return request({
      url: `/v20/getBlkInfo`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}
//2. getBlkProcess
export function getBlkProcess(param) {
    let data = param
    return request({
      url: `/v20/getBlkProcess`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}  
//3. listAllShipNo
export function listAllShipNo(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v20/listAllShipNo`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}
 
